const emptyFunction = () => {}

const defaultTrackingContextValue = {
  initialized: true,
  identified: true,
  setTrackingContextValue: emptyFunction,
  getPendingEventQueue: () => [],
  capturePendingEvents: emptyFunction,
  client: null,
  reset: false,
}
const globalTrackingContext = defaultTrackingContextValue

export const getTrackingContext = () => globalTrackingContext

export const useTrackingContext = () => {
  return {
    trackingContextValue: globalTrackingContext,
  }
}
